import { render, staticRenderFns } from "./ProjectWlcmHomeCampaigns.vue?vue&type=template&id=7488b6eb"
import script from "./ProjectWlcmHomeCampaigns.vue?vue&type=script&lang=ts"
export * from "./ProjectWlcmHomeCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports